// extracted by mini-css-extract-plugin
export default {"header":"AgFfFp9Z8SkTBm3RjrfC","row":"PdlIKs2N9oh7zBwiorxc","totalSum":"VJMdHwTUlodDQU5ggyQH","iconCell":"gJBhwPhanM1AlRokBwbG","placeHolderShimmer":"pvoBtlSciNBPTznfg2oR"};